import React, { useEffect, useState } from 'react'
import Header from '../components/Header'
import Banner from '../components/Banner'
import Categorys from '../components/Categorys'
import NewArrivalProducts from '../components/products/NewArrivalProducts'
import FeatureProducts from '../components/products/FeatureProducts'
import Footer from '../components/Footer'
import { useDispatch, useSelector } from 'react-redux'
import {
  get_discount_products,
  get_new_products,
  get_products,
} from '../store/reducers/homeReducer'
import UseSnus from '../components/UseSnus'
import InfoSection from '../components/InfoSection'
import Reklam from '../components/Reklam'

const Home = () => {
  const dispatch = useDispatch()
  const { products, newProducts } = useSelector((state) => state.home)

  const [styles, setStyles] = useState('grid')

  useEffect(() => {
    dispatch(get_discount_products())
    dispatch(get_new_products())
    dispatch(get_products())
  }, [])

  return (
    <div className="w-full">
      <Header />
      <Banner />
      <Categorys />
      <div >
        <NewArrivalProducts products={newProducts} />
      </div>

      <div className="">
        <Reklam />
      </div>
      <div>
        <FeatureProducts products={products} />
      </div>
      <div className="py-[15px]">
        <UseSnus />
      </div>
      <div className="">
        <InfoSection />
      </div>

      {/* <div className="py-10">
        <div className="w-[85%] flex flex-wrap mx-auto">
          <div className="grid w-full grid-cols-3 md-lg:grid-cols-2 md:grid-cols-1 gap-7">
            <div className="overflow-hidden">
              <Products title="Latest Product" products={latest_product} />
            </div>

            <div className="overflow-hidden">
              <Products title="Top Rated Product" products={topRated_product} />
            </div>

            <div className="overflow-hidden">
              <Products title="Discount Product" products={discount_product} />
            </div>
          </div>
        </div>
      </div> */}
      <Footer />
    </div>
  )
}

export default Home
